import styled from "styled-components";
import { Drawer } from "antd";
import { touchFriendlyControls } from "../../../styles/touchFriendly";

export const Container = styled(Drawer)`
  .ant-drawer-body {
    padding: 24px 0px 10px 0px;
  }

  .drawerForm {
    width: 100%;
    padding: 0px 24px;
    min-height: -moz-calc(100vh - 165px);
    min-height: -webkit-calc(100vh - 165px);
    min-height: calc(100vh - 165px);
    min-height: calc(100dvh - 165px);
  }

  .filterHint {
    display: block;
    margin-top: 8px;
    color: #8c8c8c;
    font-size: 12px;
    text-align: center;
  }

  .ant-collapse {
    margin-bottom: 16px;
  }

  .supplyNumberButtons {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  ${touchFriendlyControls}

  .rowLabel {
    margin: 8px 0px;
  }

  span.subTitle {
    font-size: 14px;
    color: #000;
    margin-bottom: 10px;
  }

  label {
    color: #9074bf;
    font-size: 14px;
    font-weight: bold;
    margin-left: 15px;
  }

  .error {
    color: #d44c4c;
    margin-left: 15px;
  }

  .ant-select {
    width: 100%;
  }

  input:disabled {
    color: #000;
    font-weight: 500;
  }
`;

export const Footer = styled.div`
  border-top: 1px solid #e8e8e8;
  margin-top: 20px;
  width: 100%;
  padding: 10px 24px;
  border-radius: 0 0 4px 4px;

  @media screen and (max-width: 1180px) {
    position: sticky;
    bottom: 0;
    z-index: 10;
    background: #fff;
  }

  @media (pointer: coarse) {
    button {
      min-height: 44px;
    }
  }

  .buttonsDiv {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    /* padding-right: 24px; */

    button:first-of-type {
      margin-right: 12px !important;
    }
  }

  .ant-row-flex {
    margin: 0;
  }

  .selectDiv {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    span {
      font-family: "Asap", sans-serif;
      font-size: 14px;
      font-weight: bold;
      margin-right: 8px;
    }
  }
`;
